import React from 'react';
import { MediaGallery, Render } from '../platformui/';

export default (props) => (
  <MediaGallery
    {...props}
    Heading={Render.Property(props.Heading, 'Heading')}
    Media={props.MainContent}
    Dir={'ltr'}
    NumOfImages={props.MainContent ? props.MainContent.length : 0}
    IllustratorTop={true}
    ShowPagination={false}
  />
);
